// src/components/Modals/DailyNormPraiseModal.jsx
import { useEffect, useRef } from "react";

import { ModalShell } from "../ModalShell";
import { useNestedModalEscape } from "../Templates/useNestedModalEscape";
import { DAILY_NORM_PRAISE_TEXTS } from "../../utils/dailyNormPraise";
import { fmtDMY } from "../../utils/date";

const TITLE_ID = "daily-norm-praise-title";

/**
 * Модалка похвалы за выполнение дневной нормы.
 *
 * Монтируется только когда praise !== null (см. TaskModal).
 * date - ISO-дата дня, за который сотрудник закрыл норму.
 *
 * Esc обрабатывается через useNestedModalEscape: закрывается именно
 * похвала, а не TaskModal под ней.
 *
 * Фокус ставится на кнопку «Закрыть» обычным useEffect: к моменту
 * его запуска DOM уже скоммичен, ref валиден.
 *
 * trapFocus передаётся в ModalShell → Modal: эта модалка - верхний
 * слой поверх TaskModal, Tab не должен уводить фокус в TaskModal
 * под ней. Для остальных модалок приложения поведение не меняется.
 *
 * titleId передаётся в ModalShell → Modal: это включает role="dialog"
 * и aria-labelledby именно для этой модалки.
 *
 * Классы и keyframes - в общем styles.css (раздел 48).
 */
export function DailyNormPraiseModal({ date, onClose }) {
  const closeButtonRef = useRef(null);

  useNestedModalEscape(onClose);

  useEffect(() => {
    closeButtonRef.current?.focus();
  }, []);

  return (
    <ModalShell
      title={DAILY_NORM_PRAISE_TEXTS.title}
      titleId={TITLE_ID}
      trapFocus
      onClose={onClose}
      width={420}
      className="modal-daily-praise"
      showSave={false}
      footer={
        <div className="modal-foot">
          <div className="spacer" />
          <button
            ref={closeButtonRef}
            type="button"
            className="btn primary"
            onClick={onClose}
          >
            {DAILY_NORM_PRAISE_TEXTS.closeLabel}
          </button>
        </div>
      }
    >
      <div className="daily-praise">
        <div className="daily-praise-star" aria-hidden="true">
          <span className="daily-praise-star__glyph">
            {DAILY_NORM_PRAISE_TEXTS.starGlyph}
          </span>
        </div>
        <p className="daily-praise-text">
          {DAILY_NORM_PRAISE_TEXTS.message(fmtDMY(date))}
        </p>
      </div>
    </ModalShell>
  );
}

export default DailyNormPraiseModal;
